import React from 'react';
import { Link } from 'react-router-dom';
import SubPage from '../SubPage';
import Cards from './Cards';
import D from './solData';
import { useLang } from '../../LanguageContext';

const CRUMB = { ko: 'ML-CARE 솔루션', en: 'ML-CARE Solution' };
const T = {
  title: { ko: '스마트 기저귀 소개', en: 'Smart Diaper' },
  lede:  { ko: 'IoT 센서가 배뇨·배변 상태를 실시간으로 감지하는 차세대 돌봄 솔루션입니다.',
           en: 'A next-generation care solution: IoT sensors detect urination and bowel movements in real time.' },
  h2:    { ko: '기저귀가 스스로 알려주는 교체 시점', en: 'The diaper tells you when it needs changing' },
  p1:    { ko: '메디로지스 스마트 기저귀는 기저귀에 부착된 IoT 센서가 24시간 배뇨·배변 상태를 감지하여 간병인에게 즉시 알림을 전달합니다. 감에 의존하던 기저귀 확인 작업이 데이터 기반의 정확한 케어로 바뀝니다.',
           en: 'An IoT sensor on the diaper detects urination and bowel movements around the clock and alerts the caregiver immediately. Checking by guesswork becomes precise, data-driven care.' },
  why:   { ko: '스마트 배뇨·배변 감지는 왜 필요한가요?', en: 'Why does smart detection matter?' },
  where: { ko: '어디에 적용되나요?', en: 'Where is it used?' },
  whereP:{ ko: '요양 현장뿐 아니라 돌봄이 필요한 다양한 환경에 적용됩니다.',
           en: 'Beyond nursing facilities, it fits many environments where care is needed.' },
  line:  { ko: '제품 라인업', en: 'Product Lineup' },
  lineP: { ko: '센서부터 대시보드, 보호자 앱까지 하나의 통합 패키지로 제공합니다.',
           en: 'From sensors to dashboards and the family app — delivered as one integrated package.' },
  cta1:  { ko: '작동 구조 보기', en: 'See How It Works' },
  cta2:  { ko: '도입 상담 신청', en: 'Request a Consultation' },
};

function SolIntro() {
  const { lang } = useLang();
  const [why, parts, where, lineup] = D.intro;
  return (
    <SubPage crumb={CRUMB[lang]} title={T.title[lang]} lede={T.lede[lang]}>
      <div className="sp-label">SMART DIAPER</div>
      <h2>{T.h2[lang]}</h2>
      <div className="sp-prose"><p>{T.p1[lang]}</p></div>

      <div className="sp-label sp-mt-lg">WHY</div>
      <h2>{T.why[lang]}</h2>
      <Cards items={why} cols={3} className="sp-mt" />
      <Cards items={parts} cols={3} className="sp-mt-lg" />

      <div className="sp-label sp-mt-lg">WHERE</div>
      <h2>{T.where[lang]}</h2>
      <div className="sp-prose"><p>{T.whereP[lang]}</p></div>
      <Cards items={where} cols={2} className="sp-mt" />

      <div className="sp-label sp-mt-lg">PRODUCT LINEUP</div>
      <h2>{T.line[lang]}</h2>
      <div className="sp-prose"><p>{T.lineP[lang]}</p></div>
      <Cards items={lineup} cols={2} className="sp-mt" />

      <div className="sp-cta sp-mt-lg">
        <Link className="sp-btn primary" to="/solution/structure">{T.cta1[lang]}</Link>
        <Link className="sp-btn ghost" to="/support/inquiry">{T.cta2[lang]}</Link>
      </div>
    </SubPage>
  );
}

export default SolIntro;
